<template>
    <div>
        <div class="item" v-for="(course, index) in items" :key="index" @click="viewDetail(course)">
           <div class="image-container">
               <img class="cover" :src="course.cover" :alt="course.title">
               <div class="play one one-voice-play"></div>
           </div>
            <div class="course-name" :title="course.title" v-html="course.title"></div>
        </div>
    </div>

</template>

<script>
    import file from '@/api/file'
    import storage from '@/plugins/storage'

    export default {
        name: "EntCourseItem",
        data() {
            return {
                token: storage.get('token')
            }
        },
        props: {
            items: Array
        },
        methods: {
            viewDetail(item) {
                const preRouterName = this.$router.currentRoute.name
                const {pageIndex=1,keyword=''} = this.$router.currentRoute.query
                this.$router.push(`/service-center/detail?id=${item.id}&type=liveCourse&currentRoute=${preRouterName}&keyword=${keyword}&pageIndex=${pageIndex}`)
            },
            async downloadClassFiles(item) {
                this.coursesFiles = await file.getCourseFiles({}, {paths: {courseId: item.id}})
                if (!this.coursesFiles.length) {
                    this.$Message.info('暂无附件')
                } else {
                    const course = this.coursesFiles[0]
                    if (course.lockState === 1) { // 加锁状态
                        this.$Message.info(`课件将在开课后${this.course.unlockAttachmentTime}分钟后自动解锁`)
                        return
                    }
                    let domain = process.env.NODE_ENV === 'development' ? this.$config.courseFilesDomain : ''
                    let href = `${domain}/live/api/v1/outer/file/seaFile/download/${item.id}?path=${encodeURIComponent('/')}&fileName=${encodeURIComponent(course.name)}`
                    if (this.token) {
                        href += `&school_token=${this.token}`
                    }
                    if (sessionStorage.getItem('verify-md5')) {
                        href += `&verify-md5=${sessionStorage.getItem('verify-md5')}`
                    }
                    window.location.href = href
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .item {
        float: left;
        margin: 0 20px 27px 20px;
        overflow: hidden;
        text-align: center;
        border: solid 1px #eaeaea;
        width: 248px;
        height: 190px;
        border-radius: 3px;
        .image-container{
            position: relative;
            .cover {
                width: 248px;
                height: 140px;
                cursor: pointer;
                position: relative;
                border-radius: 4px 4px 0 0;
            }

            .play {
                position: absolute;
                z-index: 200;
                right: 4px;
                bottom: 10px;
                width: 32px;
                height: 32px;
                font-family: icon-one;
                font-size: 20px;
                color: #e6e6e6;
                cursor: pointer;
            }

        }

        .course-name {
            width: 224px;
            height: 50px;
            padding-left: 13px;
            line-height: 50px;
            font-size: 14px;
            color: #000000;
            margin-top: -5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            /deep/ .search-result-highlight {
                color: #ED6C00 !important;
            }
        }

        .download {
            float: right;
            width: 16px;
            height: 16px;
            font-family: icon-one;
            font-size: 16px;
            line-height: 1;
            color: #999990;
            cursor: pointer;
            margin-top: 13px;
        }

    }
</style>
